import { founderTypes, getFounderType } from '../data/founderTypes';

export const buildTypeCode = (primaryType, secondaryType) => {
  const primary = getFounderType(primaryType);
  const secondary = secondaryType ? getFounderType(secondaryType) : null;
  if (!primary) return null;
  if (!secondary?.code) return primary.code;
  return `${primary.code}-${secondary.code}`;
};

export const buildIdentityHeadline = (profile) => {
  const primary = getFounderType(profile?.primaryType);
  const secondary = profile?.secondaryType ? getFounderType(profile.secondaryType) : null;
  if (!primary) return 'Founder';
  if (!secondary) return primary.title.replace('The ', '');
  return `${primary.title.replace('The ', '')} with ${secondary.title.replace('The ', '')} tendencies`;
};

export const buildShareHeadline = (profile) => {
  const code = buildTypeCode(profile?.primaryType, profile?.secondaryType);
  const primary = getFounderType(profile?.primaryType);
  if (!primary) return 'My founder operating profile';
  return code
    ? `My ${code} founder operating profile. ${primary.tagline}`
    : `My ${primary.title.replace('The ', '')} operating profile. ${primary.tagline}`;
};

export const applyTypeTheme = (typeId) => {
  const type = getFounderType(typeId);
  if (!type || typeof document === 'undefined') return;
  document.documentElement.style.setProperty('--type-accent', type.color);
  document.documentElement.style.setProperty('--type-accent-dark', type.colorDark);
};

export const clearTypeTheme = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.style.removeProperty('--type-accent');
  document.documentElement.style.removeProperty('--type-accent-dark');
};

export const getTypeListForNav = () =>
  Object.values(founderTypes).map((t) => ({
    id: t.id,
    code: t.code,
    title: t.title,
    color: t.color,
  }));
